module.exports = __webpack_public_path__ + "img/bigTruck-orange.ccce8a98.svg";